import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { DELETE_USER_ACCOUNT } from './types'
import styles from 'modules/User/Accounts/Accounts.module.scss'
import { Button } from 'gu-ui-kit'

const Logout = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch({ type: DELETE_USER_ACCOUNT })
  }

  return (
    <Button
      component={'a'}
      variant={'ghost'}
      link
      className={styles['accounts__connect-link']}
      onClick={handleLogout}
    >
      {t('user::settings.accounts.logout')}
    </Button>
  )
}

Logout.propTypes = {}

export default Logout
